/* eslint-disable */

import { Fragment, useState } from "react";
import ModalComponent from "../modal";
import styled from "styled-components";
import { CardStatusTabConstant } from "../../constants/app-constants";
import TabsComponent from "../tabs";
import BadgeComponent from "../badge";
import { Stack } from "@mui/material";
import ButtonComponent from "../button";
import moment from "moment";

const CardStatusModalWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 40px;
`;

const StyledTabContentLabel = styled.p`
    font-size: 14px;
`;

const StyledTabContentValue = styled.p`
    font-size: 14px;
    font-weight: 700;
    color: var(--text-color-primary);
`;

const StyledHistoryContent = styled(Stack)`
    background-color: var(--theme-color-secondary);
    padding: 14px 20px;
    border-radius: 20px;
    gap: 4px;

    p {
        font-size: 14px;

        span {
            color: var(--text-color-primary);
            font-weight: 700;
        }
    }
`;

const ViewCardStatusModal = ({ data, close, label, slide }) => {
    const tabs = [
        { label: 'Profile', value: CardStatusTabConstant?.profile },
        // { label: 'Controls', value: CardStatusTabConstant?.controls },
        // { label: 'History', value: CardStatusTabConstant?.history }
    ];

    const initialStates = {
        selectedTab: CardStatusTabConstant?.profile,
    };

    const [states, setStates] = useState(initialStates);

    const PROFILE = () => {
        const profileData = [
            {
                section: 'Card Details',
                data: [
                    { label: 'PAN', type: 'text', value: data?.pan || '-' },
                    { label: 'Status', type: 'badge', value: data?.status },
                    { label: 'Enrolled', type: 'text', value: data?.enrolled === 'YES' ? 'Yes' : 'No' },
                    { label: 'Expiry Date', type: 'text', value: moment(data?.expiryDate).format('MM / YY') || '-' },
                ]
            },
            {
                section: 'Channel Enablement',
                data: [
                    { label: 'e-commerce Domestic', type: 'text', value: (data?.domestic === 'YES' || data?.domestic === true) ? 'Enabled' : 'Disabled' },
                    { label: 'e-commerce International', type: 'text', value: (data?.international === 'YES' || data?.international === true) ? 'Enabled' : 'Disabled' },
                ]
            },
            {
                section: 'Metadata',
                data: [
                    { label: 'Last Source', type: 'text', value: data?.lastSource || '-' },
                    { label: 'Updated At', type: 'text', value: (data?.updatedDate || data?.createdDate) ? moment(data?.updatedDate || data?.createdDate).format('lll') : '-' },
                    { label: 'Updated By', type: 'text', value: data?.updatedBy || '-' },
                ]
            }
        ];
        return (
            <Stack spacing={4}> {/* p=2 added if tabs */}
                {
                    profileData.map((section, index) => (
                        <Stack key={index} spacing={2}>
                            <h6>{section.section}</h6>
                            <Stack spacing={1}>
                                {
                                    section.data.map((item, idx) => (
                                        <Stack key={idx} direction="row" flexWrap="wrap" justifyContent="space-between">
                                            <StyledTabContentLabel>{item.label}</StyledTabContentLabel>
                                            {
                                                (item.type === 'badge' && item?.value) ? (
                                                    <BadgeComponent label={item?.value?.toLowerCase()} type={
                                                        (item.value?.toLowerCase() === 'active') ? 'success' :
                                                            (item.value?.toLowerCase() === 'warm' || item.value?.toLowerCase() === 'pending' || item.value?.toLowerCase() === 'expired') ? 'warning' :
                                                                (item.value?.toLowerCase() === 'hot' || item.value?.toLowerCase() === 'blocked' || item.value?.toLowerCase() === 'block') ? 'error' :
                                                                    'default'
                                                    } />
                                                ) : (
                                                    <StyledTabContentValue>{item.value}</StyledTabContentValue>
                                                )
                                            }
                                        </Stack>
                                    ))
                                }
                            </Stack>
                        </Stack>
                    ))
                }
            </Stack>
        );
    };

    const CONTROLS = () => {
        const controlsData = [
            {
                section: 'MCC Block List',
                data: data?.mccBlocks || [],
            },
            {
                section: 'Country Block List',
                data: data?.countryBlocks || [],
            },
        ];
        return (
            <Stack spacing={4} p={2}>
                {
                    controlsData.map((section, index) => (
                        <Stack key={index} spacing={1}>
                            <h6>{section.section}</h6>
                            <Stack direction="row" flexWrap="wrap" gap={1}>
                                {
                                    section.data.map((item, idx) => (
                                        <Fragment key={idx}>
                                            <BadgeComponent label={item} type='error' />
                                        </Fragment>
                                    ))
                                }
                            </Stack>
                        </Stack>
                    ))
                }
            </Stack>
        );
    };

    const HISTORY = () => {
        return (
            <Stack spacing={1} p={2}>
                {
                    [...Array(3)].map((_, index) => (
                        <StyledHistoryContent key={index} className="box-shadow">
                            <p><span>Updated</span> {'Oct 27, 2025 15:15'}</p>
                            <p>By {'system@ingest'}</p>
                            <p>Source: {'FILE'}</p>
                        </StyledHistoryContent>
                    ))
                }
            </Stack>
        );
    };

    return (
        <ModalComponent close={close} label={label} width={500} slide={slide}>
            <CardStatusModalWrapper>
                {/* head */}
                <Stack spacing={2}>
                    <Stack spacing={0.3}>
                        <h5>Card ID: {data?.id}</h5>
                        <p>BIN: {data?.bin}</p>
                    </Stack>
                    <Stack direction="row" flexWrap="wrap" gap={1}>
                        <BadgeComponent label={data?.status?.toLowerCase()} type={
                            data?.status?.toLowerCase() === 'active' ? 'success' :
                                (data?.status?.toLowerCase() === 'warm' || data?.status?.toLowerCase() === 'pending' || data?.status?.toLowerCase() === 'expired') ? 'warning' :
                                    (data?.status?.toLowerCase() === 'hot' || data?.status?.toLowerCase() === 'blocked' || data?.status?.toLowerCase() === 'block') ? 'error' :
                                        'default'
                        } />
                        <BadgeComponent label={data?.enrolled ? 'Enrolled' : 'Not Enrolled'} type={data?.enrolled ? 'default' : 'error'} />
                    </Stack>
                </Stack>

                {/* Tabs */}
                <TabsComponent
                    // bgColor="#eaf5fe"
                    onChange={(value) => setStates((old) => ({ ...old, selectedTab: value }))}
                    tabs={tabs}
                    value={states.selectedTab}
                    heightfull
                >
                    {/* Tab Profile */}
                    {
                        states.selectedTab === CardStatusTabConstant?.profile && (
                            <PROFILE />
                        )
                    }

                    {/* Tab Controls */}
                    {/* {
                        states.selectedTab === CardStatusTabConstant?.controls && (
                            <CONTROLS />
                        )
                    } */}

                    {/* Tab History */}
                    {/* {
                        states.selectedTab === CardStatusTabConstant?.history && (
                            <HISTORY />
                        )
                    } */}
                </TabsComponent>

                <Stack direction="row" flexWrap="wrap" justifyContent="flex-end">
                    <ButtonComponent label="Close" type="button" onClick={close} />
                </Stack>
            </CardStatusModalWrapper>
        </ModalComponent>
    );
};

export default ViewCardStatusModal;
